import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { TableLoader } from "../../../../Common/ShimmerLoader";
import { VehicleWiseHookLoaderTripsReport } from "../../../../Apis/ttrReportsApi";
import CustomDataTable from "../../../../Common/ReportTable/ReportTable";
import { GetZone } from "../../../../Apis/organizationApi";
import * as XLSX from "xlsx";
import ExcelJS from "exceljs";

const ZoneWiseHookLoaderReport = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [startDate, setStartDate] = useState(getStartOfCurrentDate());
  const [endDate, setEndDate] = useState(getCurrentDateTime());
  const [isOptionsLoading, setIsOptionsLoading] = useState(false);
  const [zoneName, setZoneName] = useState("");
  const location = useLocation()

  useEffect(() => {
    if (location.state) {
      setData(location.state); // Set data when it's available
    } else {
      //fetchData(); // Fetch data when component mounts if state is not available
    }
  }, [location.state]);

//   const fetchData = async (ZoneId, VehicleTypeId) => {
//     try {
//       setIsLoading(true);
//       // Perform the API call again to fetch data
//       const requestData = { Date, VehicleTypeId, ZoneId }; // Assuming these are defined somewhere
//       const response = await innergetAllZoneWiseReport(requestData);
//       setData(response.data);
//     } catch (error) {
//       console.error("Error fetching zone wise report:", error);
//     } finally {
//       setIsLoading(false);
//     }
//   };

  //const data = location.state
  const [zonesData, setZonesData] = useState([]);


  useEffect(() => {
    const fetchZoneName = async () => {
      try {
        const zoneData = await GetZone();
        const zoneIdFromLocalStorage = localStorage.getItem("zoneId");
        const zoneNamesDictionary = {};

        // Populate the zoneNamesDictionary with zoneId as keys and zoneName as values
        zoneData.forEach((zone) => {
          zoneNamesDictionary[zone.zoneId] = zone.zoneName;
        });

        // Find the zone name corresponding to the zoneId from localStorage
        const zoneName = zoneNamesDictionary[zoneIdFromLocalStorage];

        // Use zoneName as needed
        setZoneName(zoneName);
      } catch (error) {
        console.error("Error fetching zone name:", error);
      }
    };

    fetchZoneName();
  }, []);
  const ZoneContainerColumns = [
    {
      name: "Sl.No",
      selector: (row) => row["slno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
    },
    {
      name: "Vehicle Number",
      selector: (row) => (
        <span
         style={{ color: "blue", cursor: "pointer" }}
           onClick={() => handleVehicleClick(row["vehicleNumber"])}
        >
          {row["vehicleNumber"]}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Vehicle Model",
      selector: (row) => (
        <span
        //  style={{ color: "blue" }}
        >{row["vehicleModel"]}</span>
      ),
      sortable: true,
    },
    {
      name: "No.of Trips",
      selector: (row) => (
        <span
        // style={{ color: "blue" }}
        > {row["numberOfTrip"]}</span>
      ),
      sortable: true,
    },
    {
      name: "Total QTY(MT)",
      selector: (row) => (
        <span
        //style={{ color: "blue" }}
        >{row["totalQty"]}</span>
      ),
      sortable: true,
    },
    
  ];

  const handleVehicleClick = async (vehicleNumber) => {

    try {
      setIsOptionsLoading(true);
      const response = await VehicleWiseHookLoaderTripsReport(startDate,endDate,vehicleNumber);
      navigate("/vehicle-hookloader_report", { state: response.data });
      console.log(response.data,"response")
    } catch (error) {
      console.error("Error", error);
    } finally {
      setIsOptionsLoading(false);
    }
  };

  const options = { day: 'numeric', month: 'numeric', year: 'numeric' };
  const generationTime = ` ${new Date().toLocaleString('en-GB', options).replace(/\//g, '/')}`;

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${
      currentDate.getMonth() + 1
    }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = ` ZoneWise Hookloader Report Generated on: ${generationTime},${formattedTime}`;
    // Calculate the length of the downloadDateTime string
    const downloadDateTimeLength = downloadDateTime.length;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Trips&Tonnage");
  
    // Define styles
   const boldFont = { bold: true };
  
  // Add the downloadDateTime to the correct row and columns, and ensure formatting
  worksheet.addRow(["", "", downloadDateTime, ""]); // Update array length to match new cell range
  worksheet.mergeCells(1, 2, 1, 4); // Merge cells for downloadDateTime from column 2 to 4
  worksheet.getCell(1, 2).value = downloadDateTime; // Ensure the value is set after merging
  worksheet.getCell(1, 2).font = boldFont; // Set font style
  worksheet.getCell(1, 2).alignment = { horizontal: "center" }; // Center align the content
  
  // Apply styles to the merged cells (B1, C1, D1)
  for (let col = 2; col <= 4; col++) {
    worksheet.getCell(1, col).font = boldFont; // Set styles individually
    worksheet.getCell(1, col).alignment = { horizontal: "center" }; // Center align the cell content
  }
  
  // Add "Zone Details" to the correct row and columns, and ensure formatting
  worksheet.addRow(["", "", "Zone Wise Hookloader Report", ""]); // Update array length to match new cell range
  worksheet.mergeCells(2, 2, 2, 4); // Merge cells for Zone Details from column 2 to 4
  worksheet.getCell(2, 2).value = " Zone Wise Hookloader Report"; // Ensure the value is set after merging
  worksheet.getCell(2, 2).font = boldFont; // Set font style
  worksheet.getCell(2, 2).alignment = { horizontal: "center" }; // Center align the content
  
  // Apply styles to the merged cells (B2, C2, D2)
  for (let col = 2; col <= 4; col++) {
    worksheet.getCell(2, col).font = boldFont; // Set styles individually
    worksheet.getCell(2, col).alignment = { horizontal: "center" }; // Center align the cell content
  }
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Vehicle Number",
      "Vehicle Model",
      "No.of Trips",
      "Total QTY(MT)",
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left",color:"#fff" }; // Center align the cell content
      if (colNumber >= 1 && colNumber <= 6) {
        // Apply background color and set text color
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" }, // Red background color
          bgColor: { argb: "FFFFFFFF" } // White text color
        };
      }
    });
  
    // Add data rows
    data.forEach((item, index) => {
    
      worksheet
        .addRow([
          index + 1,
          item.vehicleNumber?? "N/A",
          item.vehicleModel?? "N/A",
          item.numberOfTrip?? "N/A",
          item.totalQty?? "N/A",
       
        ])
        .eachCell({ includeEmpty: true }, (cell, colNumber) => {
          if (colNumber >= 1 && colNumber <= 6) {
            // Align the columns from 1 to 4 to the left
            cell.alignment = { horizontal: "left" };
          } else {
            // Align the rest of the columns to the center
            cell.alignment = { horizontal: "center" };
          }
        });
    });
  
    // Add total row with bold font
  
  
    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
     
    ];
  
    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Zone Wise Hookloader Report.xlsx";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="card mt-3">
              <div className="card-body p-3">
                <div className="d-flex justify-content-end mt-3 mb-3">
                  <button className="btn btn-secondary  me-2" style={{}}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                  <button className="btn btn-excel"
                    onClick={downloadAsExcel}
                  >
                    <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                  </button>

                </div>

                <div className="top-header">
                  <span>
                    {" "}
                    Zone Wise HookLoader Report
                  </span>
                </div>
                {data &&
                  <CustomDataTable
                    data={data}
                    columns={ZoneContainerColumns}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ZoneWiseHookLoaderReport;


const getStartOfCurrentDate = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}T00:00`;
  };
  
  // Function to get current date and time in the required format
  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hour = String(now.getHours()).padStart(2, "0");
    const minute = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hour}:${minute}`;
  };